import React from "react";
import { Link } from "react-router-dom";
import { formatCoords } from "../lib/coords";
import { tokenImage } from "../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function TokenCard({ token, onMint }) {
    const img = tokenImage(token.lat, token.lon);
    const isSold = token.status === "sold";
    const isTop = token.phase === "top_token";
    return (
        <div
            data-testid={`token-card-${token.number}`}
            className="group relative bg-slate-900/40 border border-white/10 hover:border-frost/50 transition-all duration-300 hover:-translate-y-1 flex flex-col"
        >
            {isTop && (
                <span className="absolute top-2 right-2 z-10 bg-gold text-obsidian text-[10px] font-bold px-2 py-1 uppercase tracking-widest">
                    Top
                </span>
            )}
            <div className="aspect-[4/3] overflow-hidden border-b border-white/10 relative bg-slate-950">
                {img ? (
                    <img
                        src={img}
                        alt={`Parcel #${token.number}`}
                        className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
                        onError={(e) => {
                            e.currentTarget.style.display = "none";
                        }}
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center">
                        <div className="w-32 h-32 rounded-full border border-frost/30 flex items-center justify-center">
                            <div className="w-16 h-16 rounded-full bg-frost/10 border border-frost/40 flex items-center justify-center text-frost text-xs font-mono">
                                #{token.number}
                            </div>
                        </div>
                    </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent opacity-60" />
                {token.title && (
                    <div className="absolute bottom-2 left-2 right-2 font-serif text-xl text-white drop-shadow-lg">
                        {token.title}
                    </div>
                )}
            </div>
            <div className="p-4 flex flex-col gap-2">
                <div className="flex justify-between items-start">
                    <div>
                        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
                            Token
                        </div>
                        <div className="font-serif text-2xl">#{token.number.toLocaleString()}</div>
                    </div>
                    <div className="text-right">
                        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
                            {isTop ? "Base" : "Price"}
                        </div>
                        <div className="font-mono text-frost">
                            {token.price.toLocaleString()} <span className="text-xs">USDC</span>
                        </div>
                    </div>
                </div>
                <div className="text-xs font-mono text-slate-400">
                    {formatCoords(token.lat, token.lon)}
                </div>
                <div className="mt-2 flex gap-2">
                    <Link
                        to={`/token/${token.number}`}
                        data-testid={`token-card-detail-${token.number}`}
                        className="flex-1 btn-sharp text-center border border-white/15 px-3 py-2 text-xs hover:border-frost hover:text-frost"
                    >
                        Detail
                    </Link>
                    {!isSold && !isTop && onMint && (
                        <button
                            data-testid={`token-card-mint-${token.number}`}
                            onClick={() => onMint(token)}
                            className="flex-1 btn-sharp bg-white text-obsidian px-3 py-2 text-xs hover:bg-slate-200 inline-flex items-center justify-center gap-1"
                        >
                            Mint <ArrowUpRight className="w-3 h-3" />
                        </button>
                    )}
                    {isSold && (
                        <span className="flex-1 btn-sharp text-center bg-slate-800 text-slate-400 px-3 py-2 text-xs">
                            Sold
                        </span>
                    )}
                    {isTop && (
                        <Link
                            to={`/auctions`}
                            data-testid={`token-card-bid-${token.number}`}
                            className="flex-1 btn-sharp text-center bg-aurora text-obsidian px-3 py-2 text-xs hover:bg-amber-400"
                        >
                            Bid
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
